import { FC, memo } from 'react';
import { useWritebackStore } from '../../../../../../../../provider';
import DuplicateRecordsInfoContent from './duplicate-record-info-content/duplicate-record-info-content.component';

const DuplicateRecordsInfo: FC = () => {
  const { sourceTenantIdsWithDuplicateRecords } = useWritebackStore(['sourceTenantIdsWithDuplicateRecords']);

  if (sourceTenantIdsWithDuplicateRecords.length === 0) {
    return null;
  }

  return <DuplicateRecordsInfoContent />;
};

export default memo(DuplicateRecordsInfo);
